import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { FaVolumeUp, FaVolumeMute } from "react-icons/fa";
import "../assets/Music.css"

const BackgroundMusic = () => {
  const audioRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const [hasInteracted, setHasInteracted] = useState(false);

  useEffect(() => {
    const enableAudio = () => {
      if (!hasInteracted) {
        setHasInteracted(true);
        setIsMuted(false);
        setTimeout(() => {
          if (audioRef.current) {
            audioRef.current.muted = false;
            audioRef.current.play().catch((e) =>
              console.warn("Play blocked:", e)
            );
          }
        }, 100);
      }
    };

    document.addEventListener("click", enableAudio);
    return () => document.removeEventListener("click", enableAudio);
  }, [hasInteracted]);

  const toggleMute = () => {
    setIsMuted((prev) => {
      const newMuted = !prev;
      if (audioRef.current) audioRef.current.muted = newMuted;
      return newMuted;
    });
  };

  return (
    <>
      <audio
        ref={audioRef}
        src="/music.mp3" 
        loop
        muted
        autoPlay
      />
      <Button
  onClick={toggleMute}
  className="mute-button"
>
  {isMuted ? (
    <FaVolumeMute size={22} />
  ) : (
    <FaVolumeUp size={22} />
  )}
</Button>
    </>
  );
};

export default BackgroundMusic;